/**
 * @generated SignedSource<<5ea76d5fbb9675d7d662a2fde976284f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShowSellerSince_viewer">;
  readonly " $fragmentType": "SellerTile_viewer";
};
export type SellerTile_viewer$key = {
  readonly " $data"?: SellerTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSellerSince_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "43cc3e72d99ba8e3afef38823693a746";

export default node;
